<template>
  <div>
    <ul v-if="externalLinks !== undefined">
      <li v-for="(externalLink, index) in externalLinks" v-bind:key="index" class="mt-2">
        <a @click="openLink(externalLink)" class="button-primary block" >{{ externalLink.Label }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      externalLinks: this.route.course.External
    }
  },
  methods: {
    openLink: function (externalLink){
      // GoogleAnalytics
      this.$gtag.event("外部リンク", {
        link_label: externalLink.Label,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.$store.getters['user/getToken']
      });
      window.open(externalLink.Url)
    }
  }
}
</script>
